export enum EServerError {
  CONFLICT = 'conflict',
  INVALID_CREDENTIALS = 'invalid_credentials',
  TFA_REQUIRED = '2fa_required',
  TFA_UNCONFIGURED = '2fa_unconfigured',
  OTP_COOLDOWN = 'otp_cooldown',
  OTP_INVALID = 'otp_invalid',
  OTP_EXPIRED = 'otp_expired',
  OTP_MAX_ATTEMPTS = 'otp_max_attempts',
  WRONG_MIMETYPE = 'file_wrong_mimetype',
  DEVICE_ID_ALREADY_REGISTERED = 'device_id_already_registered',
  PHONE_ALREADY_REGISTERED = 'phone_already_registered',
  EMAIL_ALREADY_REGISTERED = 'email_already_registered',
  USER_ALREADY_REGISTERED = 'user_already_registered',
  USER_ALREADY_EXISTS = 'user_already_exists',
  USER_HAS_ROLES_IN_OTHER_INSTITUTIONS = 'user_has_roles_in_other_institutions',
  // The user holds no role in any institution and is not a superadmin.
  NO_INSTITUTION_ASSIGNED = 'no_institution_assigned',
  DUPLICATE_NPI = 'duplicate_npi',
  ALREADY_ORGANIZATION_ADMIN = 'already_organization_admin',
  DIFFERENT_ORGANIZATION = 'different_organization',
  USER_IN_OTHER_ORGANIZATION = 'user_in_other_organization',
  CANNOT_DELETE_LAST_ROLE = 'cannot_delete_last_role',
  ORGANIZATION_ADMIN_CANNOT_BE_PATIENT = 'organization_admin_cannot_be_patient',
  PATIENT_CANNOT_BE_ORGANIZATION_ADMIN = 'patient_cannot_be_organization_admin',
  ORGANIZATION_ADMIN_CANNOT_BE_DEACTIVATED = 'organization_admin_cannot_be_deactivated',
  INSUFFICIENT_PROVIDER_SEATS = 'insufficient_provider_seats',
  NOT_INSTITUTION_PROVISIONED = 'not_institution_provisioned',
  PRESENTER_SINGLE_INSTITUTION = 'presenter_single_institution',
  PRESENTER_MEDWAND_DISABLED = 'presenter_medwand_disabled',
  UNKNOWN_ERROR = 'unknown_error',
  BAD_PARAMS = 'bad_params',
}

// Error codes returned via /login?error=<code> after an SSO (Google/Microsoft) callback.
export enum ESsoLoginError {
  // No account matches the provider identity or its email.
  USER_NOT_FOUND = 'user_not_found',
  // Account exists but is deactivated.
  USER_INACTIVE = 'user_inactive',
  // Account exists but is not a patient (SSO login is patient-only).
  NOT_PERMITTED = 'not_permitted',
  // The IdP did not assert a verified email.
  EMAIL_NOT_VERIFIED = 'email_not_verified',
  // Generic fallback for anything else.
  CALLBACK_ERROR = 'callback_error',
}
